import { act, useEffect, useState } from "react";
import "./App.css";
import profile from "./assets/profile.png";
import Loader from "./Loader";
import { ActiveUsers } from "./ActiveUsers";
import { LeaderBoard } from "./LeaderBoard";
import { fetchData } from "./api"; // Import the function
import RewardVideo from "./RewardAd";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebaseConfig";

import {saveTelegramLog} from "./SaveTelegramLog"

export default function Home() {
  const [loading, setLoading] = useState(true);
  const [cloud, setCloud] = useState(global.getProfileData());
  const [claimData, setClaimData] = useState(global.getClaimData());
  const [emrsPriceOne, setEmrsPriceOne] = useState("0.00");
  const [emrsPriceTwo, setEmrsPriceTwo] = useState("0.00");
  const [conversionPrice, setConversionPrice] = useState(0.00041);
  const [widthLine, setWidthLine] = useState(20);
  const [username, setUsername] = useState("User Name");
  const [activeToken, setActiveToken] = useState("");

  const [telegramUserId, setTelegramUserId] = useState(0);

  


  const checkMergingRequired = () => {
    const tg = window.Telegram.WebApp;
    const user = tg.initDataUnsafe?.user;
    //  || {
    //   first_name: "Vijit",
    //   last_name: "Singhai",
    //   id: 90002,
    //   username: "justvijit",
    //   photo_url:
    //     "https://t.me/i/userpic/320/xoTIlGHhF_fxKB8znaEKXXh-XrK3z4kqxDpdt1O0jQwnmqpY1yLosyZQsVIP7cls.svg",
    // };
    const tgUserId = user.id;
    setTelegramUserId(tgUserId);
    const myHeaders = new Headers();
    const raw = "";
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    
    fetch(
      "https://api.emorya.com/telegram/user-exists?telegramId=" + tgUserId,
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          mergeUsers(tgUserId);
          console.log("response not okay 12");
          console.log(JSON.stringify(response));
          setLoading(false);
          //throw new Error(`HTTP error! Status: ${response.status}`);
        }else{
          getData();
        }
        
        return response.text();
      })
      .then((result) => {
        result = JSON.parse(result);
      })
      .catch((error) => {
        console.log("from catch");
        console.log('Logout From 11',error);
        global.goToSignIn();
        setLoading(false);
        console.error(error);
      });
  }

  const mergeUsers = (telegramId) => {
    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Token " + activeToken);
    const bodyData = JSON.stringify({
      telegramId: telegramId, 
    });
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
      body: bodyData, 
    };
    
    fetch("https://api.emorya.com/telegram/user-connect", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        result = JSON.parse(result);
        console.log(JSON.stringify(result));
        setLoading(false);
        getData();
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
        getData();
      });
  };

  const getData = () => {
    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", "Token " + activeToken);
    const raw = "";
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    fetch(global.getBaseUrl() + "/user", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        
        result = JSON.parse(result);
        console.log(JSON.stringify(result));
        if (result.error && result.message.indexOf('Unauthorized') !== -1) {
          console.log('Logout From 1',result);
          global.logoutNow();
        }
        if (!result.userData.age || result.userData.age == null) {
          global.disableOtherPages();
        } else {
          setUsername(
            result.userData.firstName + " " + result.userData.lastName
          );
          setCloud(result);
          var erOne = result.transferableEMRS;

          setEmrsPriceOne(erOne);
          getClaimData();
          setLoading(false);
        }
      })
      .catch((error) => {
        alert("Unable to get your data, please logout and then login again.");
        setLoading(false);
      });
  };


  const claimEmrs = () => {
    hideAdNow();
    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", "Token " + activeToken);
    const raw = "";
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
    };
    fetch(global.getBaseUrl() + "/claim-bmr-calories", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        result = JSON.parse(result);

        if (result.error && result.message.indexOf('Unauthorized') !== -1) {
          global.logoutNow();
        } else {
          getClaimData();
          saveTelegramLog();
        }

        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  const getClaimData = () => {
    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", "Token " + activeToken);
    const raw = "";
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    fetch(global.getBaseUrl() + "/claim-bmr-calories", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        result = JSON.parse(result);
        if (result.error && result.message.indexOf('Unauthorized') !== -1) {
          console.log('Logout From 3',result);
          global.logoutNow();
        } else {
          setClaimData(result);
          var erOne = result.daily_total_calories;
//          erOne = parseFloat(erOne).toFixed(4);
          setEmrsPriceTwo(erOne);
          if (result.daily_total_calories !== 0) {
            var ww =
              result.claimed_calories_today / result.daily_total_calories;
            ww = ww * 100;
            ww = parseInt(ww);
            setWidthLine(ww);
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  const [refreshToken,setRefreshToken] = useState(null)


  useEffect(() => {
    onAuthStateChanged(auth, async (user) => {
      console.log('Auth state change called');
      if (user) {
        const token = await user.getIdToken(true);


        

        var data = {
          token: token,
          email: user.email,
          name: user.displayName,
          refreshToken: user.refreshToken,
          localId: user.reloadUserInfo.localId,
          photoURL: user.photoURL,
          phoneNumber: user.phoneNumber,
        };
        data = JSON.stringify(data);
        localStorage.setItem("USERDATA", data);

        updateLoginStatus();
        
      } else {
        console.log("User is not signed in.");
        //global.logoutNow()
        updateLoginStatus();
      }
    });
  }, []);

  useEffect(() => {
    if (activeToken != "") {
      checkMergingRequired();
      document.cookie = "authToken="+activeToken+"; path=/; domain=.emorya.com; Secure; SameSite=None";
      document.cookie = "refreshToken="+refreshToken+"; path=/; domain=.emorya.com; Secure; SameSite=None";
    }
  }, [activeToken,refreshToken]);
 
  const updateLoginStatus = () => {
    if (localStorage.getItem("USERDATA")) {
      var dd = localStorage.getItem("USERDATA");
      dd = JSON.parse(dd);
      setUsername(dd.name);
      setActiveToken(dd.token);
      setRefreshToken(dd.refreshToken)
    } else {
      console.log('Logout From 4');
      global.logoutNow();
    }
  }


  const getEMRSPrice = async () => {
    const response = await fetchData("https://api.emorya.com/emrs-price");
    if (response) {
      var price = response[0].usdPrice;
      console.log(price);
      setConversionPrice(price);
    }
  };

  useEffect(() => {
    getEMRSPrice();
  }, []);


    const showAds = () => {
      setAdDisplay(true);
    };
    const hideAdNow = () => {
      setAdDisplay(false);
    };
    const [adDisplay, setAdDisplay] = useState(false);
  
    const [logs, setLogs] = useState([]);

    useEffect(() => {
      const originalLog = console.log;
      console.log = (...args) => {
        setLogs(prev => [...prev, args.join(" ")]);
        originalLog(...args); // Still print to the real console
      };
  
      return () => {
        console.log = originalLog; // cleanup
      };
    }, []);
  
  return (
    <>
     {adDisplay ? (
        <>
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.8)",
              minHeight:'100%',
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 200000,
              padding:20
            }}
          >
            <RewardVideo
              callBack={claimEmrs}
              callBackArgs={""}
            ></RewardVideo>
          </div>
        </>
      ) : null}
      <div className="section">
        <div
          style={{
            padding: 10,
            paddingTop: 20,
            textAlign: "left",
            width: "100%",
          }}
        >
          <Loader loading={loading}></Loader>
          <div
            className="row"
            style={{
              width: "100%",
              margin: 0,
            }}
          >
            <div className="col-2">
              <div
                className="profileImage"
                style={{
                  backgroundImage:
                    cloud.userData.imageUrl &&
                    cloud.userData.imageUrl != "" &&
                    cloud.userData.imageUrl != null
                      ? `url(${cloud.userData.imageUrl})`
                      : `url(${profile})`,
                }}
              ></div>
            </div>
            <div className="col-10">
              <div
                className="dashedBottom"
                style={{
                  fontWeight: "bold",
                }}
              >
                {username}
              </div>
              <div
                style={{
                  fontSize: 11,
                  paddingTop: 5,
                }}
              >
                Max NFT Level : {cloud.nftLevel}
                <div
                  style={{
                    float: "right",
                  }}
                >
                  {cloud.totalCalories} kCal
                </div>
              </div>
            </div>
            <div
              className="col-sm-12"
              style={{
                padding: "40px 10px",
              }}
            >
              <br />
            
              <div className="glowBox">
                <div
                  style={{
                    padding: 20,
                  }}
                >
                  <div
                    style={{
                      float: "right",
                    }}
                  >
                    <img
                      alt=""
                      src={require("./assets/mono.png")}
                      style={{
                        width: 40,
                      }}
                    ></img>
                  </div>
                  <strong
                    style={{
                      fontSize: 16,
                    }}
                  >
                    {parseFloat(cloud.transferableEMRS).toFixed(2)} EMRS
                    {
                      (telegramUserId !== 7874266965) ? "." : null
                    }
                  </strong>
                  <div
                    style={{
                      fontSize: 12,
                    }}
                  >
                    = $ {(emrsPriceOne * conversionPrice).toFixed(4)}
                  </div>
                  <br />
                  <div
                    style={{
                      fontSize: 14,
                      fontWeight: "bold",
                    }}
                  >
                    <div
                      style={{
                        float: "right",
                        fontSize: 11,
                        color: "#fff",
                        fontWeight: "normal",
                      }}
                    >
                      <span
                        style={{
                          fontSize: 15,
                          color: "#fff",
                          fontWeight: "bold",
                        }}
                      >
                        {claimData.claimed_calories_today}
                      </span>
                      /{claimData.daily_total_calories} ( =
                        $ {(emrsPriceTwo * conversionPrice).toFixed(4)})
                    </div>
                    Daily Calories
                    <div
                      style={{
                        backgroundColor: "#482253",
                        borderColor: "#482253",
                        borderWidth: 1,
                        borderStyle: "solid",
                        borderRadius: 5,
                        position: "relative",
                        width: "100%",
                        height: 32,
                        overflow: "hidden",
                        marginTop: 10,
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#DB5E9C",
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: widthLine + "%",
                          height: 30,
                        }}
                      ></div>
                    </div>
                    <br />
                    <div className="dashedBottom"></div>
                    <br />
                    <strong
                      style={{
                        color: "#DB5E9C",
                        fontSize: 40,
                      }}
                    >
                      {claimData.claimable_calories} kCal
                    </strong>
                    <div
                      style={{
                        fontSize: 12,
                        marginTop: -5,
                      }}
                    >
                      Claimable Calories
                      <br/>
                   
                    </div>
                    <button
                      onClick={() => {
                        showAds();

                      }}
                      className="btn btn-sm btn-success gradColor"
                      style={{
                        marginTop: 10,
                      }}
                    >
                      Claim Now <i className="fas fa-arrow-right"></i>
                    </button>
                    <br />
                  </div>
                </div>
              </div>
              <br />


              <br />
{
  (activeToken !== "") ? <>
            <LeaderBoard activeToken={activeToken}></LeaderBoard>
  </>:
  null
}
  
              <div className="glowBox">
                <ActiveUsers></ActiveUsers>
              </div>

            
              <br />
              <br />


              <div
                style={{
                  padding: 20,
                  display:'none'
                }}
              >
                <strong
                  style={{
                    fontSize: 30,
                  }}
                >
                  Burn Calories <br />
                  And Make Money!
                </strong>
                <br />
                <div
                  style={{
                    fontSize: 14,
                  }}
                >
                  Burn calories and get rewards, simple and easy, right from
                  your phone.
                </div>
                <br />
                <button
                  className="btn btn-sm btn-light"
                  onClick={() => {
                    global.changeSection("CALCULATOR");
                  }}
                >
                  <i
                    className="fa-solid fa-border-none"
                    style={{
                      fontSize: 12,
                      marginTop: -3,
                    }}
                  ></i>
                  &nbsp; Calculate How <i className="fas fa-arrow-right"></i>
                </button>
                <br />
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
